// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "project" + "-legacy." + "9d238cd1" + ".js";
};